 import React, { useEffect, useState } from "react";
import { LoadScript, LoadScriptNext, StandaloneSearchBox } from "@react-google-maps/api";

const libraries = ["places"];

export default function LocationSearchDropdown({ onSelect,value="" }) {
  const [inputValue, setInputValue] = useState(value || "");
  const [searchBox, setSearchBox] = useState(null);
  useEffect(() => {
  setInputValue(value || ""); // ✅ keep input in sync if Formik value changes
}, [value]);

  const handlePlacesChanged = () => {
if (!searchBox) return;

    const places = searchBox.getPlaces();
    if (!places || places.length === 0) return;

    const place = places[0];
    const location = place.geometry.location;
   const components = place.address_components || [];

    const formattedAddress = {
      name: place.formatted_address || "",
      streetAddress:
        components.find((c) => c.types.includes("route"))?.long_name || "",
      city:
      components.find((c) => c.types.includes("locality"))?.long_name || "",
      state:
     components.find((c) =>
          c.types.includes("administrative_area_level_1")
        )?.short_name || "",
      pincode:
      components.find((c) => c.types.includes("postal_code"))?.long_name ||
        "",
      country:
        components.find((c) => c.types.includes("country"))?.long_name || "",
      location: {
        type: "Point",
        coordinates: [location.lng(), location.lat()],
      },
    };


    

    onSelect(formattedAddress); // send data back to parent (Formik form)
  };
 

  return (
    <div className="p-2">
      <LoadScriptNext
        googleMapsApiKey="AIzaSyDNGZZw7AKHWyq8TA_YiBC4A09d5NhZLDk"
        libraries={libraries}
      > 
        <StandaloneSearchBox onLoad={(ref) => setSearchBox(ref)} onPlacesChanged={handlePlacesChanged} className="pac-container" >
          <input
            type="text"
    value={inputValue} 
          onChange={(e) => setInputValue(e.target.value)}
            placeholder="Search address"
            style={{ width: "100%", padding: "8px", border: "1.2px solid #0AB7EA" ,borderRadius:"10px"}}
          />
        </StandaloneSearchBox>
      </LoadScriptNext> 
    </div>
  );
}
 


 